import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';

import Icon from 'components/atoms/Icon';
import MbButton from 'components/atoms/MbButton';
import PopoverFooter from 'components/atoms/PopoverFooter';
import TableToolBarIconButton from 'components/atoms/TableToolBarIconButton';
import MbCheckList from 'components/molecules/MbCheckList';

const useStyles = makeStyles((theme) => ({
  popoverRoot: {
    zIndex: theme.zIndex.popOver + ' !important',
  },
  popoverPaper: {
    maxWidth: 500,
    maxHeight: 600,
    borderRadius: 4,
    boxShadow: '-0.8px -0.6px 11px 0 rgba(16,17,21,0.05)',
    border: 'solid 1px',
    borderColor: theme.palette.primary.deep,
    padding: 20,
  },
  columnTitle: {
    fontSize: 16,
    textAlign: 'left',
  },
  columnNotice: {
    lineHeight: 3,
    textAlign: 'left',
    color: theme.palette.primary.deep,
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  resetButton: {
    fontSize: 15,
  },
}));

/**
 * 컬럼 커스텀 버튼
 * @param {json} props
 */
let saveBtnDisabled = true;
export default function SetUpList({
  list,
  customized,
  title,
  popoverTitle,
  popoverNotice,
  saveButtonTitle,
  handleSaveCustomSet,
  icon,
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [customColumn, setCustomColumn] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    saveBtnDisabled = true;
  }, []);

  useEffect(() => {
    if (list.size !== 0) {
      setCustomColumn(new Map(list));
    }
  }, [list]);

  /**
   * 컬럼 숨김 popover 열기
   */
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   * 컬럼 설정 list 클릭
   * @param {string} id 컬럼 아이디
   */
  const handleSetColumn = (id) => () => {
    const newCustomColumn = new Map(customColumn);
    const column = newCustomColumn.get(id);
    newCustomColumn.set(id, { ...column, displayFlag: !column.displayFlag });

    // 기존 값과 비교
    for (let item of list.values()) {
      const { id, displayFlag } = item;
      if (newCustomColumn.get(id).displayFlag !== displayFlag) {
        saveBtnDisabled = false;
        continue;
      }
    }
    setCustomColumn(newCustomColumn);
  };

  /**
   * 컬럼 설정 저장
   */
  const handleSaveClick = () => {
    handleSaveCustomSet(customColumn);
    setAnchorEl(null);
  };

  /**
   * 전체 선택
   */
  const handleOnClick = (flag) => {
    const newCustomColumn = new Map(customColumn);

    for (let item of newCustomColumn.values()) {
      const { id } = item;
      const column = newCustomColumn.get(id);
      newCustomColumn.set(id, { ...column, displayFlag: flag });
    }
    setCustomColumn(newCustomColumn);
  };

  /**
   * 선택초기화
   */
  const handleResetClick = () => {
    if (list.size !== 0) {
      setCustomColumn(new Map(list));
    }
  };

  /**
   * 컬럼생성
   */
  const makeList = () => {
    const result = [];
    const newCustomColumn = new Map(customColumn);

    for (let item of newCustomColumn.values()) {
      let isChecked;
      let merged = false;
      const { id, label } = item;
      let realLabel = label;

      if (typeof customized !== 'undefined') {
        if (typeof customized[id] !== 'undefined') {
          if (typeof customized[id].merged !== 'undefined') merged = true;
          if (typeof customized[id].makeHead !== 'undefined') {
            let result = customized[id].makeHead(list);
            let customLabelContent = result.content;
            if (typeof customLabelContent !== 'undefined') {
              if (typeof customLabelContent.props.children === 'string') {
                realLabel = customLabelContent.props.children;
              } else {
                if (typeof customLabelContent.props.children[0] === 'string') {
                  realLabel = customLabelContent.props.children[0];
                }
              }
            }
          }
        }
      }

      if (id === 'SEQ' || merged === true) {
        continue;
      }

      isChecked = customColumn.get(id).displayFlag;
      result.push(
        <MbCheckList
          key={id}
          onClick={handleSetColumn(id)}
          checked={isChecked}
          label={realLabel}
        />
      );
    }
    saveBtnDisabled = false;
    return result;
  };

  return (
    <>
      <TableToolBarIconButton
        aria-describedby={id}
        aria-label={title}
        onClick={handleClick}
        icon={
          !icon ? (
            <Icon
              icon={'faList'}
              color={theme.palette.primary.main}
              style={{ fontSize: 18 }}
            />
          ) : (
            icon
          )
        }
        label={title}
        color={theme.palette.primary.main}
      />
      <Popover
        id={id}
        classes={{ root: classes.popoverRoot, paper: classes.popoverPaper }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Typography gutterBottom>
          <span className={classes.columnTitle}>{popoverTitle}</span>
          <span className={classes.columnNotice}>* {popoverNotice}</span>
        </Typography>
        {Boolean(customColumn) && (
          <div className={classes.list}>{makeList()}</div>
        )}
        <PopoverFooter>
          <div>
            <Button className={classes.resetButton} onClick={handleResetClick}>
              {t('초기화')}
            </Button>
            <Button
              className={classes.resetButton}
              onClick={() => handleOnClick(true)}
            >
              {t('전체선택')}
            </Button>
            <Button
              className={classes.resetButton}
              onClick={() => handleOnClick(false)}
            >
              {t('전체해제')}
            </Button>
          </div>
          <div>
            <MbButton
              color={theme.palette.primary.deep}
              disabled={saveBtnDisabled}
              onClick={handleSaveClick}
            >
              {saveButtonTitle}
            </MbButton>
          </div>
        </PopoverFooter>
      </Popover>
    </>
  );
}
